<template>
  <div class="contents-part">
    <div class="column-part">
      <div class="column-title">旅游时间是否有特殊要求：</div>
      <div class="label-part">
        <div class="select-part">
          <el-checkbox
          v-for="date in STR"
          :key="date.id"
          v-model="date.choose"
          >
            {{ date.name }}
          </el-checkbox>
        </div>
      </div>
    </div>
    <div class="column-part" style="margin-top:38px">
      <div class="column-title">旅途中比较注重那些方面：</div>
      <div class="label-part">
        <div class="select-part">
          <el-checkbox
          v-for="date in PAA"
          :key="date.id"
           v-model="date.choose"
          >{{ date.name }}</el-checkbox>
        </div>
      </div>
    </div>
    <div class="column-part" style="margin-top:38px">
      <div class="column-title" style="margin-top: 0.2rem">理想中的旅游天数：</div>
      <div class="label-part" style="margin-left: 90px">
        <el-checkbox
         v-for="date in DT"
         :key="date.id"
         v-model="date.choose"
        >{{ date.name }}</el-checkbox>
      </div>
    </div>
    <div class="column-part" style="margin-top:38px">
      <div class="column-title">出游过程中更想体验哪方面：</div>
      <div class="label-part" style="margin-left: 27px">
        <div class="select-part">
          <el-checkbox
          v-for="date in EP"
          :key="date.id"
          v-model="date.choose"
          >{{ date.name }}</el-checkbox>
        </div>
      </div>
    </div>
    <button class="hold"
    @click="holdInfo"
    >保存信息</button>
  </div>
</template>

<script>
import axios from "../../axios/axios";
import ipAddress from "../../axios/ipAddress";
import {Message} from "element-ui";

export default {
  name: "serAdvisCompile",
  data() {
    return{
      id:'',
      STR:[],
      PAA:[],
      DT:[],
      EP:[],
      SBINFO:{}
    }
  },
  created() {
    this.id = this.$route.params.id;
    this.lookTravelInfo()
  },
  methods:{
    //查看旅游咨询相关信息
    lookTravelInfo(){
      let params = new URLSearchParams()
      params.set("customerId",this.id)
      axios.post(`${ipAddress.qi}/admin/a1/serve-survey/getByCid`,params).then(
        value =>{
          const content = value.content
          this.STR = content.time
          this.PAA = content.journey
          this.DT = content.days
          this.EP = content.experience
          this.SBINFO = JSON.parse(JSON.stringify(content))
        }
      )
    },

    //点击保存信息
    holdInfo(){
      if(!((JSON.stringify(this.STR) == JSON.stringify(this.SBINFO.time))
        && (JSON.stringify(this.PAA) == JSON.stringify(this.SBINFO.journey))
        && (JSON.stringify(this.DT) == JSON.stringify(this.SBINFO.days))
        && (JSON.stringify(this.EP) == JSON.stringify(this.SBINFO.experience))
      )){   //说明修改过内容
          let params = {
            customerId:this.id,
            time:this.STR.filter(el =>el.choose),
            journey:this.PAA.filter(el =>el.choose),
            days:this.DT.filter(el =>el.choose),
            experience:this.EP.filter(el =>el.choose)
          }

          axios.post(`${ipAddress.qi}/admin/a1/serve-survey/upByCid`,params,true).then(
            value => {
              const success = value.success
              const msg = value.message
              if(success){
                Message.success("保存成功！")
                this.$router.replace(`/index/customers/serviceAdvisory/${this.id}`)
              }else {
                Message.warning(msg)
              }
            }
          )
      }
    },
  },
  watch:{
    $route:{
      handler(from,to){
        const fromId = from.params.id
        const  toId = to.params.id
        if(!(fromId == toId)){
          this.id = toId;
          this.lookTravelInfo()
        }
      }
    }
  }
}
</script>

<style scoped>
.contents-part {
  width: auto;
  height: auto;
  margin-left: 7rem;
}

.column-part {
  width: 100%;
  height: auto;
  display: flex;
}

.column-title {
  width: auto;
  height: auto;
  font-size: 0.9rem;
  letter-spacing: 1px;
  color: black;
  white-space: nowrap;
}

.label-part {
  width: auto;
  word-break: break-all;
  word-wrap: break-word;
  margin-left: 42px;
  display: flex;
  flex-wrap: wrap;
}

.select-part {
  width: auto;
  height: auto;
  font-size: 0.95rem;
  letter-spacing: 1px
}
.hold{
  padding:0.6rem 1.2rem;
  background-color: #0f86da;
  font-size: 0.95rem;
  letter-spacing:2px;
  color: white;
  border-radius: 8px;
  border: none;
  margin-top: 27px;
  margin-bottom: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Customer/serAdvisCompile.vue